module.exports = __webpack_public_path__ + "img/AMY_25s.8243db76.jpg";